import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dataFilter'
})
export class DataFilterPipe implements PipeTransform {

    transform(array: any[], query: any, col: string[]): any {
        let result = new Array<any>();
        if (query) {
            if (col) {
                for (let i = 0; i < col.length; i++) {

                    let res = _.filter(array,
                        function (row) {
                            console.log(typeof row[col[i]]);
                            if (row[col[i]] == null){
                                return false;
                            }
                            switch (typeof row[col[i]]) {
                                case 'string':
                                    return row[col[i]].toLowerCase().indexOf(query.toLowerCase()) > -1;
                                case 'number':
                                    return row[col[i]].toString() === query > -1;
                                default:
                                    return false;
                            }
                        });

                    for (let x = 0; x < res.length; x++) {
                        if (result.indexOf(res[x]) == -1) {
                            result.push(res[x]);
                        }
                    }

                }
                return result;
            }
        }
        return array;
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/pipes/datafilter.pipe.ts